export default __webpack_public_path__ + "static/media/verify-identity.ae9e2dd2.png";